<template>
    <div class="">
        <van-nav-bar style="" title="还款计划" fixed/>
        <van-row style="margin: 46px 0 50px 0">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    error-text="请求失败，点击重新加载"
                    @load="onLoad">
                <van-cell>
                <van-row style="text-align: center">
                    <van-col span="1">
                        序
                    </van-col>
                    <van-col span="4">
                        本金
                    </van-col>
                    <van-col span="4">
                        利息
                    </van-col>
                    <van-col span="4">
                        费用
                    </van-col>
                    <van-col span="4">
                        状态
                    </van-col>
                    <van-col span="7">
                        预期还款
                    </van-col>
                </van-row>
                </van-cell>
                <van-cell
                        style="padding: 20px"
                        v-for="item in list"
                        center>
                    <template>
                       <van-row style="text-align: center">
                           <van-col span="1">
                               {{item.periodNo}}
                           </van-col>
                           <van-col span="4">
                               {{item.principalAmount}}
                           </van-col>
                           <van-col span="4">
                               {{item.interestAmount}}
                           </van-col>
                           <van-col span="4">
                               {{item.costAmount}}
                           </van-col>
                           <van-col span="4">
                               {{item.statusCn}}
                           </van-col>
                           <van-col span="7">
                               {{item.requiredRepayDate | day}}
                           </van-col>
                       </van-row>
                    </template>
                </van-cell>
            </van-list>
        </van-row>
    </div>
</template>

<script>
  import { repayPlan } from '@/api/loanInfo'
  import moment from 'moment'
  export default {
    name: 'repay-plan',
    props: {
      applyId: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        loading: false,
        finished: false,
        list: [],
      }
    },
    mounted() {
    },
    methods: {
      onLoad() {
        let params = {
          applyId: this.applyId
        }
        repayPlan(params).then(res => {
          if(res.success){
            this.list = res.data.result
          }

          // 加载状态结束
          this.loading = false
          this.finished = true
        })
      }
    }
  }
</script>

<style scoped>

</style>
